import Carossel from "../../../carousel/carousel";
import H2Title from "../../../text/h2Title/h2Title";
import "./nossosParceirosStyle.css"
import LogoParceiro from "./subComponents/logoParceiro";

export default function NossosParceiros({title, companies}) {

    const screenWidth = window.innerWidth; 
    
    if (!companies) {
            return(
            <></>
            )
        }
    return (
        <article className="nossos-parceiros__container">
            <H2Title title={title} color="white" width={"100%"}/>
            
                { screenWidth >= 1025 ?
                    <div className="nossos-parceiros__caroussel">
                        <Carossel duration={500}>
                            {[...companies,...companies,...companies,...companies,].map((item, index) => (
                                <LogoParceiro photo={item?.photo} name={item?.name} link={item?.link} isMobile={false} key={index}/>
                            ))}
                        </Carossel>
                    </div>
                :
                    <div className="nossos-parceiros__imagens-container">
                        {companies.map((item, index) => (
                                <LogoParceiro photo={item?.photo} name={item?.name} link={item?.link} key={index}/>
                        ))}
                    </div>
                }
            
        </article>
    );
}